import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import Power from "../../assets/Power.png";

const PowerSteeringFlush = () => {
  return (
    <>
      <SeoHead
        title="Power Steering Flush in Temecula | Advanced Automotive Smog"
        description="Power steering fluid flush in Temecula to reduce noise and strain on the pump and rack, keeping your steering smooth and responsive."
        path="/services/power-steering-flush"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Power Steering Flush"
          path="/services/power-steering-flush"
          description="Power steering fluid flush in Temecula to reduce noise and strain on the pump and rack, keeping your steering smooth and responsive."
          serviceType="Power steering flush"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          
          {/* Image Section (mobile priority) */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={Power}
                alt="Power steering flush"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Section */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Steering System
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Power Steering Flush
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Keep your steering system smooth, quiet, and responsive with a
              professional power steering flush. Old or contaminated fluid can
              lead to noise, stiffness, and premature wear—our service keeps
              everything operating at its best.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is a Power Steering Flush?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Power steering fluid breaks down over time and collects debris,
              which can cause extra strain on the steering pump and rack.
              <br />
              <br />
              A flush removes the old fluid and replaces it with new,
              high-quality fluid to keep your steering smooth and extend system
              lifespan.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Comprehensive cleaning of old steering fluid
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Reduces steering noise and stiffness
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Refilled with high-quality manufacturer-spec fluid
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Helps prevent pump and rack damage
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Improves steering smoothness and response
              </li>
            </ul>

            {/* Clean Button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default PowerSteeringFlush;

